var router = require('pjax').Router;
var index = require('./index.js');
var show = require('./show.js');

router.get('order', index);
router.get('order/:any', show);
